<template>
  <div class="road-content">
    <div v-for="road in roadDetail">
      <div v-html="road.content">
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>

<script>
import { mapState } from 'vuex'
import global from '../components/public/Common.vue';

export default {
  name: 'author',
  computed: {
    ...mapState({
      author: state => state.AuthorStore.author,
      other: state => state.AuthorStore.other,
      pathName: state => state.SelectStore.pathName
    })
  },
  data() {
    return {
      id: '',
      roadDetail:[],
      imgPath:''
    }
  },
  updated:function () {
    //设置图片居中
    $(".road-content img").css({"display":"block","margin":"10px auto"})
  },
  created: function () {
    this.id = this.$route.query.id;
    let _this = this;
    //查询地区
    $.ajax({
      url: global.serviceUrl+'/',
      type: 'post',
      dataType: 'jsonp',
      data: {token:global.token,'catid':41,"id":_this.id,'orgid':global.orgid},
      success: function (data) {
        if (data.msg == 200) {
          //第一次进页面查询地区
          _this.roadDetail = data.result;
        } else {
          alert(data.msg);
        }
      },
      error: function (data) {

      }
    });

  },
  mounted:function(){

  },
  watch: {
     //利用watch方法检测路由变化：
    '$route': function (to, from) {
      // 拿到目标参数 to.query.id 去再次请求数据接口
      this.id = to.query.id;

    }
  },
  methods: {

  },
}
</script>

<style lang="stylus">
   .road-content{
     width:1200px;margin: 0 auto;text-align: center;min-height: 500px;
   }
   .road-content img{
     max-width:96%;
   }
</style>



// WEBPACK FOOTER //
// src/components/RoadShowDetail.vue